import { render, staticRenderFns } from "./EditAutoBlockModal.vue?vue&type=template&id=b353dc52&scoped=true&"
import script from "./EditAutoBlockModal.vue?vue&type=script&lang=js&"
export * from "./EditAutoBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAutoBlockModal.vue?vue&type=style&index=0&id=b353dc52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b353dc52",
  null
  
)

export default component.exports